import { language } from "./helpers";

const zipLength = language() === "hu" ? "4" : "5";

const phoneLength = language() === "hu" ? "12" : "13";

const phoneDefaultValue =
  language() === "hu" ? "+36" : language() === "sk" ? "+421" : "+420";

const deliveryFields = {
  name: {
    type: "input",
    placeholder_key: "First name",
    rules: "required",
    classes: "col-6",
  },
  surname: {
    type: "input",
    placeholder_key: "Last name",
    rules: "required",
    classes: "col-6",
  },
  address: {
    type: "input",
    placeholder_key: "Address",
    rules: "required",
    classes: "col-md-3 col-6",
  },
  number: {
    type: "input",
    placeholder_key: "Number",
    rules: "required",
    classes: "col-md-3 col-6",
  },
  city: {
    type: "input",
    placeholder_key: "City",
    rules: "required",
    classes: "col-md-3 col-6",
  },
  zip: {
    type: "input",
    placeholder_key: "Zip",
    rules: `required|digits:${zipLength}`,
    maxlength: zipLength,
    classes: "col-md-3 col-6",
  },
  email: {
    type: "email",
    placeholder_key: "Email",
    rules: "required|email",
    classes: "col-6",
  },
  phone: {
    type: "input",
    placeholder_key: "Phone number",
    rules: "required|phone",
    classes: "col-6",
    defaultValue: phoneDefaultValue,
    maxlength: phoneLength,
  },
  notes: {
    type: "textarea",
    placeholder_key: "Notes",
    rules: "",
    classes: "col-12",
  },
};

export { deliveryFields };
